import { format, toBig } from '@talos/kyoko';
import Big from 'big.js';

export function getEffectivePriceIncrement({
  requestedPriceIncrement,
  securityMinPriceIncrement,
}: {
  requestedPriceIncrement: string | undefined;
  securityMinPriceIncrement: string | undefined;
}): string | undefined {
  const requestedPriceIncrementBig = toBig(requestedPriceIncrement);
  const securityMinPriceIncrementBig = toBig(securityMinPriceIncrement);

  if (!requestedPriceIncrementBig || requestedPriceIncrementBig.lte(0)) {
    return securityMinPriceIncrementBig?.gt(0) ? securityMinPriceIncrement : requestedPriceIncrement;
  }

  if (!securityMinPriceIncrementBig || securityMinPriceIncrementBig.lte(0)) {
    return requestedPriceIncrement;
  }

  return requestedPriceIncrementBig.gte(securityMinPriceIncrementBig)
    ? requestedPriceIncrement
    : securityMinPriceIncrement;
}

export function getPriceGridPrimedPrice({
  isBPSPricing,
  isBookMode,
  price,
  priceIncrement,
}: {
  isBPSPricing: boolean;
  isBookMode: boolean;
  price: string;
  priceIncrement: string | undefined;
}): string {
  if (!isBookMode || isBPSPricing || !priceIncrement) {
    return price;
  }

  const priceBig = toBig(price);
  const incrementBig = toBig(priceIncrement);
  if (!priceBig || !incrementBig || incrementBig.lte(0)) {
    return price;
  }

  const roundedToTick = priceBig.div(incrementBig).round(0, Big.roundHalfUp).times(incrementBig);
  return format(roundedToTick, { pretty: false, round: true, spec: priceIncrement });
}
